<script setup lang="ts">
import SvgIcon from "~/components/Common/SvgIcon.vue";
import Tooltip from "~/components/Common/Tooltip.vue";

withDefaults(defineProps<{ label?: string }>(), {
  label: "Pré-rempli par l'IA à partir du programme. Vérifiez la valeur avant d'enregistrer.",
});
</script>

<template>
  <Tooltip position="top-right">
    <template #img>
      <SvgIcon name="ai" class="h-[14px] w-[14px] shrink-0 text-ai-accent-color" />
    </template>
    <template #content>
      <!-- Fixed width: shrink-to-fit against the 14px trigger would collapse the text to one word per line. -->
      <span class="meta block w-[320px]">{{ label }}</span>
    </template>
  </Tooltip>
</template>
